import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { ProductsBiocatchEnum, StepBiocatchEnum, } from 'src/app/shared/enums/biocatchContext.enum';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { IncomesService } from 'src/app/shared/services/incomes/incomes.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { OpEnum } from '../../../shared/enums/op.enum';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { IdentificationService } from '../../../shared/services/identification/identification.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { ERROR_LIB } from 'src/app/shared/constants/abre-cuentas.constants';
import { DaliService } from '@dali/tagger-ng8';
import { PAGEVIEW as PAGEVIEW_FA, CHANNEL as CHANNEL_FA, COUNTRY as COUNTRY_FA, BUSINNESS as BUSINNESS_FA, ENVIRONMENT as ENVIRONMENT_FA, FAMILY as FAMILY_FA, SUBFAMILY as SUBFAMILY_FA, PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { EVENT as EVENT_FA_LD } from 'src/app/shared/constants/dali-fa-ld.constants';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
var UpdateDataComponent = /** @class */ (function () {
    /**
     * Constructor of the component.
     *
     * @param {HeaderService}     headerService     Injectable headerService service.
     * @param {NavigationService} navigationService Injectable navigationService service.
     * @function headerService.show() Hides header
     */
    function UpdateDataComponent(copyService, taggingServices, navigationService, headerService, abreCuentasService, validationHelperService, captureService, configurationService, requestService, parametersService, identificationService, bitacoraService, bioCatchService, productLoaderService, firmlyApprovedService, incomesService, helperService, adjustEvent, channelCommunicatorService, daliService) {
        this.copyService = copyService;
        this.taggingServices = taggingServices;
        this.navigationService = navigationService;
        this.headerService = headerService;
        this.abreCuentasService = abreCuentasService;
        this.validationHelperService = validationHelperService;
        this.captureService = captureService;
        this.configurationService = configurationService;
        this.requestService = requestService;
        this.parametersService = parametersService;
        this.identificationService = identificationService;
        this.bitacoraService = bitacoraService;
        this.bioCatchService = bioCatchService;
        this.productLoaderService = productLoaderService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.incomesService = incomesService;
        this.helperService = helperService;
        this.adjustEvent = adjustEvent;
        this.channelCommunicatorService = channelCommunicatorService;
        this.daliService = daliService;
        this.options = [];
        this.closeLoading = false;
        this.loanNormalization = false;
        this.headerService.show(false, false, false);
    }
    /**
     * Función de Angular ejecutada una vez el componente sea cargado
     *
     * *Angular function that is run when the component is loaded*
     */
    UpdateDataComponent.prototype.ngOnInit = function () {
        this.callIncomes();
        this.documentInfo = this.abreCuentasService.getDocumentInfo();
        this.options = this.abreCuentasService.getBusinessConfig(OpEnum.CITY_LIST);
        this.occupationSelected = this.abreCuentasService.getOccupationSelected();
        this.productSelected = this.abreCuentasService.getproductSelected();
        this.data = this.abreCuentasService.getAbreCuentasModel();
        this.inferredIncomes = this.abreCuentasService.getinfoInferredIncomes();
        if (this.productSelected) {
            var product = this.productSelected.product_code;
            if (product === ProductsBiocatchEnum.NOM) {
                this.bioCatchService.changeContext(StepBiocatchEnum.captura, product, false);
            }
            this.product_code = this.productSelected.product_code;
            this.product_type = this.productSelected.product_type;
        }
        else {
            this.product_code = '';
            this.product_type = '';
        }
        var parms = {
            issusedIdentType: this.documentInfo.document_type,
            issusedIdentValue: this.documentInfo.document_number,
        };
        var nowDate = new Date();
        var basic = this.abreCuentasService.getCustomerData().basic;
        var lastUpdateDate = new Date(basic.last_update_date);
        var configClient = this.parametersService.getSetting(OpEnum.CONFIG_CLIENT_EXIST);
        lastUpdateDate.setDate(lastUpdateDate.getDate() + configClient.days_update);
        if (this.firmlyApprovedService.isEmpty() &&
            this.firmlyApprovedService.getOfferType_Channel() !== 'En_firme') {
            this.mandatoryUpdate = true;
        }
        else {
            this.mandatoryUpdate = false;
        }
        this.mandatoryUpdate = lastUpdateDate.getTime() < nowDate.getTime();
        console.warn('VALIDACIÓN UPDATE-DATA >>>>>\n profession: ', basic.profession, this.occupationSelected, '\n lastUpdateDate: ', lastUpdateDate, '\n basic: ', basic, '\n ConfigClient: ', configClient);
        if (basic.profession !== this.occupationSelected.name) {
            this.mandatoryUpdate = true;
        }
        if (!this.validationHelperService.isValidExistingClient()) {
            console.log('Validaciones: ', this.validationHelperService.isValidExistingClient());
            this.mandatoryUpdate = true;
        }
        if (basic.marital_status === '' || basic.marital_status === undefined) {
            this.mandatoryUpdate = true;
        }
        this.is_loading_complete = true;
        if (this.mandatoryUpdate === true) {
            this.navigationService.pageLoadTag(false, ['pv432', '', 'pv86', '']);
        }
        if (this.taggingServices.isFirmlyAprovedMono()) {
            if (basic.profession !== this.occupationSelected.name) {
                this.sendUpdateDataChangeOccupationPageLoad();
            }
            else if (lastUpdateDate.getTime() < nowDate.getTime() || this.mandatoryUpdate) {
                this.sendOutdatePageLoad();
            }
            else {
                this.sendUpdateDataVolunteerPageLoad();
            }
        }
        // this.mandatoryUpdate === true ?
        // this.bitacoraService.saveDataInBitacora('client_update_data_mandatory')
        // : this.bitacoraService.saveDataInBitacora('client_update_data_optional');
        // if(this.mandatoryUpdate === false) {
        // this.navigationService.pageLoadTag(false, ['pv431', '', 'pv82', '']);
        // }
    };
    UpdateDataComponent.prototype.callIncomes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var strTypeProduct;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        strTypeProduct = this.abreCuentasService.getproductSelected().product_type;
                        if (!(strTypeProduct === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.captureService
                                .sendProspectOccupation()
                                .then(function (res) {
                                var nextCode = '';
                                if (res) {
                                    _this.abreCuentasService.setinfoInferredIncomes(res.body.data);
                                    if (!res.status || res.status === 500) {
                                        nextCode = '500';
                                    }
                                    else if (res.status !== 200) {
                                        var codigo = res.body.data.codigo;
                                        switch (codigo) {
                                            case '422-06':
                                                nextCode = '106';
                                                break;
                                            case '422-07':
                                                nextCode = '106';
                                                break;
                                            case '400':
                                                nextCode = '500';
                                                break;
                                        }
                                    }
                                    else if (res.body.data.income_amount.amount === 0) {
                                        nextCode = '106';
                                    }
                                    else {
                                        nextCode = '000';
                                    }
                                }
                                else {
                                    nextCode = '500';
                                }
                                if (nextCode !== '' && nextCode !== '000') {
                                    _this.navigationService.navigateToGeneralInformation(nextCode);
                                }
                            })
                                .catch(function () {
                                return _this.navigationService.navigateToGeneralInformation('500');
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    UpdateDataComponent.prototype.pageTagEvent = function () {
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        try {
            var changes = [
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"]
                        .value,
                },
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].value,
                },
            ];
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.button,
                    position: EVENT.customCategory.position.bottom,
                },
                action: EVENT.customAction.click,
                label: '',
            };
            this.taggingServices.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log(error);
        }
    };
    /**
     * event next step
     */
    UpdateDataComponent.prototype.nextYes = function () {
        if (this.taggingServices.isFirmlyAprovedMono()) {
            this.sendYesButtonEvent();
        }
        this.abreCuentasService.setUpdateClient(true);
        this.pageTagEvent();
        this.navigationService.nextStep('201');
    };
    UpdateDataComponent.prototype.nextNo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var strTypeProduct, error_1, housingList, contactInfo, modelInfo, e_1, e_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.taggingServices.isFirmlyAprovedMono()) {
                            this.sendNoButtonEvent();
                        }
                        strTypeProduct = this.abreCuentasService.getproductSelected().product_type;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!(strTypeProduct === BUSINESS_CONST.MULTI || this.abreCuentasService.haveLoan)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.incomesService.callIncomes()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.handleError();
                        return [3 /*break*/, 5];
                    case 5:
                        housingList = this.parametersService.getSetting('housingType_list');
                        this.livingResidence =
                            this.abreCuentasService.getCustomerData().basic.housing_type;
                        this.livingResidence = this.livingResidence
                            ? this.helperService.validateDiacritialMask(this.livingResidence)
                            : '';
                        contactInfo = this.abreCuentasService.getContactInfo();
                        modelInfo = {
                            description: housingList.find(function (filter) { return filter.name === _this.livingResidence; }).name,
                            housingId: housingList.find(function (filter) { return filter.name === _this.livingResidence; }).id,
                        };
                        contactInfo.address.housingType = modelInfo;
                        this.pageTagEvent();
                        this.validationHelperService.setCustomerDataClient();
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 9, , 10]);
                        return [4 /*yield*/, this.captureService.createContactInfo()];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, this.captureService.prospectAddresses()];
                    case 8:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        e_1 = _a.sent();
                        console.log('Updtae-Data >>>>> Linea 187 >>>> Error consumiendo CaptureService >>>> ', e_1);
                        this.handleError();
                        return [3 /*break*/, 10];
                    case 10:
                        this.abreCuentasService.setContactInfo(contactInfo);
                        if (!((this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
                            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
                            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN ||
                            this.product_type === BUSINESS_CONST.MULTI) &&
                            this.firmlyApprovedService.isEmpty() &&
                            this.firmlyApprovedService.getOfferType_Channel() !== 'En_firme')) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.getPcoAmount()];
                    case 11:
                        _a.sent();
                        if (!this.pcoAmountValidation) {
                            console.log('Updtae-Data >>>>> Entró por False PCO AmountValidation >>>>> Linea 195 ');
                            return [2 /*return*/];
                        }
                        _a.label = 12;
                    case 12:
                        _a.trys.push([12, 16, , 17]);
                        return [4 /*yield*/, this.captureService.createFinancials()];
                    case 13:
                        _a.sent();
                        if (!((this.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
                            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL ||
                            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
                            this.product_type === BUSINESS_CONST.MULTI)
                            && !this.firmlyApprovedService.isFirmlyApproved())) return [3 /*break*/, 15];
                        return [4 /*yield*/, this.captureService.createClient()];
                    case 14:
                        _a.sent();
                        _a.label = 15;
                    case 15:
                        this.advance();
                        return [3 /*break*/, 17];
                    case 16:
                        e_2 = _a.sent();
                        console.log('Updtae-Data >>>>> Linea 207 >>>> Error consumiendo >>>> ', e_2);
                        this.handleError();
                        return [3 /*break*/, 17];
                    case 17: return [2 /*return*/];
                }
            });
        });
    };
    UpdateDataComponent.prototype.closeApp = function () {
        this.navigationService.loadExitScreen = true;
    };
    UpdateDataComponent.prototype.handleError = function () {
        this.navigationService.navigateToGeneralInformation('500');
    };
    UpdateDataComponent.prototype.clickTwoLink = function (event) {
        switch (event.item.content) {
            case 'Salir':
                this.navigationService.goToLoginPage();
                break;
            case 'Cancelar':
                break;
        }
        this.navigationService.loadExitScreen = false;
    };
    UpdateDataComponent.prototype.getPcoAmount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.productLoaderService.show(this.copyService.copies.show_load_pco, this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
                        this.bitacoraService.saveDataInBitacora('Ini_loading_PCO');
                        return [4 /*yield*/, this.captureService.performPco().then(function (result) {
                                if (result !== '200') {
                                    _this.navigationService.navigateToGeneralInformation('127');
                                    return;
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.abreCuentasService.sleep(this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO'])];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.captureService.getChannelComunicator(false, true).then(function (result2) {
                                _this.pcoAmountValidation = true;
                                if (result2 === '107' || result2 === '121' || result2 === '130' || result2 === '129' || result2 === '124' || result2 === '127') {
                                    // if (result2 === '129') {
                                    //   this.navigationService.pageLoadTag('ErrorProcesoEnTramite', ['pv426', '', 'pv572', '']);
                                    // }
                                    if (result2 === '121') {
                                        _this.navigationService.pageLoadTag('ErrorSolicitudNoAprobada', ['pv438', '', '', '']);
                                    }
                                    _this.navigationService.navigateToGeneralInformation(result2);
                                    _this.pcoAmountValidation = false;
                                }
                                if (result2 === '17') {
                                    _this.loanNormalization = true;
                                    _this.navigationService.navigateToGeneralInformation(ERROR_LIB.CODE);
                                    _this.bitacoraService.saveDataInBitacora('Normalization_yes');
                                }
                                else {
                                    _this.bitacoraService.saveDataInBitacora('Out_loading_PCO');
                                    _this.closeLoading = true;
                                }
                            }).catch(function () { return _this.navigationService.navigateToGeneralInformation('107'); })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UpdateDataComponent.prototype.prospectAddresses = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.captureService.prospectAddresses();
                return [2 /*return*/];
            });
        });
    };
    UpdateDataComponent.prototype.advance = function () {
        var bitacoraEvent = "client_no_update_data";
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        this.abreCuentasService.hideGenericLoading();
        if (this.abreCuentasService.isGrayZone() && (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
            this.product_type === BUSINESS_CONST.MULTI)) {
            this.navigationService.nextStep('202');
            this.checkLoading();
            return;
        }
        if (!this.loanNormalization) {
            this.navigationService.nextStep('200');
        }
        this.checkLoading();
    };
    UpdateDataComponent.prototype.checkLoading = function () {
        if (this.closeLoading) {
            this.productLoaderService.hide();
        }
    };
    UpdateDataComponent.prototype.isIndependentOrWorker = function () {
        return (this.occupationSelected.name === 'Empleado' ||
            this.occupationSelected.name === 'Independiente');
    };
    /* ------------- Taggeo ------------- */
    /* ------------ Taggeo - PageLoad - Actaulización de datos voluntaria ------------ */
    UpdateDataComponent.prototype.sendUpdateDataVolunteerPageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var changes = [
            {
                path: PAGEVIEW_FA.pv4pageName.path,
                value: (isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking) + ":" + COUNTRY_FA.co + ":" + BUSINNESS_FA.pf + ":" + ENVIRONMENT_FA.loggeado + ":" + FAMILY_FA.services + ":" + SUBFAMILY_FA.request + ":" + PRODUCT_FA.request + ":" + PAGEVIEW_FA.pv4pageName.value,
            },
            {
                path: PAGEVIEW_FA.pv4pageFamily.path,
                value: PAGEVIEW_FA.pv4pageFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv4subFamily.path,
                value: PAGEVIEW_FA.pv4subFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv4pageAction.path,
                value: PAGEVIEW_FA.pv4pageAction.value,
            },
            {
                path: PAGEVIEW_FA.pv4pageid.path,
                value: UpdateDataComponent.name,
            },
            {
                path: PAGEVIEW_FA.pv4transactionName.path,
                value: "" + PAGEVIEW_FA.pv4transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
            {
                path: PAGEVIEW_FA.pv4transactionTransactionStep.path,
                value: PAGEVIEW_FA.pv4transactionTransactionStep.value,
            },
        ];
        this.taggingServices.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* ------------ Taggeo - PageLoad - Actaulización de obligatoria por datos desactualizados ------------ */
    UpdateDataComponent.prototype.sendOutdatePageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var changes = [
            {
                path: PAGEVIEW_FA.pv5pageName.path,
                value: (isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking) + ":" + COUNTRY_FA.co + ":" + BUSINNESS_FA.pf + ":" + ENVIRONMENT_FA.loggeado + ":" + FAMILY_FA.services + ":" + SUBFAMILY_FA.request + ":" + PRODUCT_FA.request + ":" + PAGEVIEW_FA.pv5pageName.value,
            },
            {
                path: PAGEVIEW_FA.pv5pageFamily.path,
                value: PAGEVIEW_FA.pv5pageFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv5subFamily.path,
                value: PAGEVIEW_FA.pv5subFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv5pageAction.path,
                value: PAGEVIEW_FA.pv5pageAction.value,
            },
            {
                path: PAGEVIEW_FA.pv5pageid.path,
                value: UpdateDataComponent.name,
            },
            {
                path: PAGEVIEW_FA.pv5transactionName.path,
                value: "" + PAGEVIEW_FA.pv5transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
            {
                path: PAGEVIEW_FA.pv5transactionTransactionStep.path,
                value: PAGEVIEW_FA.pv5transactionTransactionStep.value,
            },
        ];
        this.taggingServices.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* ------------ Taggeo - PageLoad - Actaulización de datos obligatoria por cambio de ocupación ------------ */
    UpdateDataComponent.prototype.sendUpdateDataChangeOccupationPageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var changes = [
            {
                path: PAGEVIEW_FA.pv6pageName.path,
                value: (isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking) + ":" + COUNTRY_FA.co + ":" + BUSINNESS_FA.pf + ":" + ENVIRONMENT_FA.loggeado + ":" + FAMILY_FA.services + ":" + SUBFAMILY_FA.request + ":" + PRODUCT_FA.request + ":" + PAGEVIEW_FA.pv6pageName.value,
            },
            {
                path: PAGEVIEW_FA.pv6pageFamily.path,
                value: PAGEVIEW_FA.pv6pageFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv6subFamily.path,
                value: PAGEVIEW_FA.pv6subFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv6pageAction.path,
                value: PAGEVIEW_FA.pv6pageAction.value,
            },
            {
                path: PAGEVIEW_FA.pv6pageid.path,
                value: UpdateDataComponent.name,
            },
            {
                path: PAGEVIEW_FA.pv6transactionName.path,
                value: "" + PAGEVIEW_FA.pv6transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
            {
                path: PAGEVIEW_FA.pv6transactionTransactionStep.path,
                value: PAGEVIEW_FA.pv6transactionTransactionStep.value,
            },
        ];
        this.taggingServices.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* -------------- Taggeo - Events ------------- */
    UpdateDataComponent.prototype.sendYesButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_LD.pv5E1setData.pv5E1transactionTransactionStep.path,
                value: EVENT_FA_LD.pv5E1setData.pv5E1transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv5E1setData.pv5E1transactionName.path,
                value: "" + EVENT_FA_LD.pv5E1setData.pv5E1transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.center,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv5E1customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    UpdateDataComponent.prototype.sendNoButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_LD.pv5E2setData.pv5E2transactionTransactionStep.path,
                value: EVENT_FA_LD.pv5E2setData.pv5E2transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_LD.pv5E2setData.pv5E2transactionName.path,
                value: "" + EVENT_FA_LD.pv5E2setData.pv5E2transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_LD.customCategory.module.body,
                type: EVENT_FA_LD.customCategory.type.button,
                position: EVENT_FA_LD.customCategory.position.center,
            },
            action: EVENT_FA_LD.customAction.click,
            label: EVENT_FA_LD.pv5E2customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    return UpdateDataComponent;
}());
export { UpdateDataComponent };
